import { Component, Input, OnInit } from '@angular/core';
import { ColumnMode } from '@swimlane/ngx-datatable';
import * as dayjs from 'dayjs';
import { Date_range } from 'src/app/core/models/date-range';
import { UserService } from 'src/app/services/user/user.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import Swal from 'sweetalert2';




@Component({
  selector: 'app-user-actions',
  templateUrl: './user-actions.component.html',
  styleUrls: ['./user-actions.component.scss']
})
export class UserActionsComponent implements OnInit {
	@Input() user_id: number;
	@Input() userInfo: any;
	@Input() showTitle: boolean = true;
	@Input() showName: boolean = false;

	actions = [];
	ColumnMode = ColumnMode;
	dateRange_: Date_range = {
			dateStart: dayjs(new Date()).subtract(7, 'day'),
			dateEnd: dayjs(new Date()),
		};

  constructor(private userSrv: UserService, public utils: UtilsService) { }

  ngOnInit() {
	this.getUserActions();
  }

  	getUserActions() {
		const start_date = this.dateRange_.dateStart.format('YYYY-MM-DD');
		const end_date = this.dateRange_.dateEnd.format('YYYY-MM-DD');

		this.userSrv.getUserActions(this.user_id, start_date, end_date).subscribe(
			(data: any) => {
				this.actions = data.body;
			},
			(error) => {
				Swal.fire({
					icon: 'error',
					title: 'Error fetching user actions',
					text: error,
					showCancelButton: false,
					confirmButtonText: 'Ok',
				});
			}
		);
	}

		async exportActionsToPDF(){
		this.utils.generarPDFConTabla(
			this.actions,
			['Action Description', 'Date and time', 'IpV4', 'IpV6'],
			'Actions History',
			{
				user: this.userInfo.name,
				company: this.userInfo.company_name
			},
			`${this.userInfo.name}_actions_history.pdf`,
			['action_description', 'date_time', 'ipv4', 'ipv6']
		);
	}

}
